import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MessageType } from 'src/app/core/models/sms';
import { SmsService } from 'src/app/core/services/sms.service';
import { Order } from '../../models/order';
import { buildMessageText } from '../../utils/sms-builder';

@Component({
    selector: 'app-sms-message-modal',
    templateUrl: './send-sms.component.html',
    styleUrls: ['./send-sms.component.scss']
})
export class SmsMessageModalComponent {
    @Input() orderId!: string;
    @Input() address!: string;
    @Input() phoneNumber!: string;
    @Input() branchName!: string;
    @Input() branchId!: string;

    readonly MessageType = MessageType;
    selectedMessageType: MessageType = MessageType.CourierWaiting;
    etaMinutes: number = 5;
    isSending = false;
    error: string | null = null;


    constructor(
        private modalController: ModalController,
        private smsService: SmsService
    ) { }

    get messagePreview(): string {
        return buildMessageText(this.selectedMessageType, this.branchId, this.branchName, {
            etaMinutes: this.etaMinutes,
            address: this.address
        });
    }

    async confirm(): Promise<void> {
        this.isSending = true;
        this.error = null;

        try {
            await this.smsService.sendText(
                this.orderId,
                this.phoneNumber,
                this.selectedMessageType,
                this.branchId,
                this.branchName,
                {
                    etaMinutes: this.etaMinutes,
                    address: this.address
                }
            );
            this.modalController.dismiss({ success: true });
        } catch (err) {
            this.error = 'Fout bij versturen van het bericht. Probeer opnieuw.';
        } finally {
            this.isSending = false;
        }
    }

    onEtaChange(event: any): void {
        this.etaMinutes = event.detail.value;
    }
    increaseEta(): void {
        this.etaMinutes++;
    }

    decreaseEta(): void {
        if (this.etaMinutes > 1) {
            this.etaMinutes--;
        }
    }

    onEtaInput(event: any): void {
        const value = parseInt(event.target.value, 10);
        if (!isNaN(value) && value > 0) {
            this.etaMinutes = value;
        }
    }

    cancel(): void {
        this.modalController.dismiss();
    }
}
